import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

Vue.prototype.bus = new Vue()

// global variables
// Vue.prototype.$slUser = ""
// Vue.prototype.$slToken = ""
// Vue.prototype.$payEnabled = false

import VueSimpleAlert from "vue-simple-alert"
Vue.use(VueSimpleAlert)

import VueExcelXlsx from "vue-excel-xlsx"
Vue.use(VueExcelXlsx)

import { firebase } from '@firebase/app'

const firebaseConfig = {
  apiKey: "AIzaSyCI09AvfFfMuNkhvLIJujspEvjaCe2ten0",
  authDomain: "timekeeper-264503.firebaseapp.com",
  projectId: "timekeeper-264503",
  messagingSenderId: "183021784010",
  appId: "1:183021784010:web:1a1fe110a37a3b29479d33",
}

firebase.initializeApp(firebaseConfig);

//import { firebase } from '@firebase/app'
import "firebase/auth"

import './registerServiceWorker'

Vue.mixin({
  methods: {
    getUserOrg() {
      return(this.$store.state.orgId)
    },

    saveUserProfile(orgId, orgName, enableTL, enablePL, enableSU){
      this.$store.commit('set', ['orgId', orgId])
      this.$store.commit('set', ['orgName', orgName])
      this.$store.commit('set', ['enableTL', enableTL])
      this.$store.commit('set', ['enablePL', enablePL])
      this.$store.commit('set', ['enableSU', enableSU])
    }

  },
})

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
